import React from "react";


import serviceImg from "../../assets/images/service/1.png";

const SingleService = (props) => {
  const { itemClass, itemImg, btnText, title } = props;
  return (
    <div className={itemClass ? itemClass : "item__inner"}>
      <div className="item__inner">
        <div className="icon">
          <img src={itemImg ? itemImg : serviceImg} alt="" />
        </div>
        <div className="react-content">
          <h3 className="react-title">{title}</h3>
          <div className="learn-more">
            {btnText ? btnText : "Learn More"}{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-arrow-right"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleService;
